export const SUBSCRIBE_FORM_COOKIE_PREFIX = 'prezly-subscribe-form-';
